<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 12 12" enable-background="new 0 0 12 12" xml:space="preserve">
  <g stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
    <line x1="1" y1="3" x2="11" y2="3" id="Line" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
    <line x1="1" y1="9" x2="11" y2="9" id="Line" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
  </g>
</svg>
